var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Columnbanner"},[(_vm.banner)?_c('img',{staticClass:"absolute left-1/2 transform -translate-x-1/2",attrs:{"src":_vm.banner,"alt":""}}):_vm._e(),_c('div',{staticClass:"stand relative"},[_vm._t("default")],2),(_vm.isBreadcrumb)?_c('MyBreadcrumb'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }